import React from "react";
import WorkOrderInfo from "./components/workOrderInfo";
import AssignWorkOrder from "./components/assignWorkOrder";
import UrgentWorkOrder from "./components/urgentWorkOrder";
import EstimateProcess from "./components/estimateProcess";
import OwnerApprovalNeeded from "./components/ownerApprovalNeeded";
import CityCitation from "./components/cityCitation";
import DelCityInspection from "./components/delCityInspection";
import SectionEight from "./components/sectionEight";
import CancelWorkOrder from "./components/cancelWorkOrder";
import WorkOrderCompleted from "./components/workOrderCompleted";

const WorkOrderFollowUp = ({ itemId, listId, checkedItems }) => {

  return (
    <div>
      {itemId === 1 && (
        <WorkOrderInfo
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 2 && (
        <AssignWorkOrder
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 3 && (
        <UrgentWorkOrder
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 4 && (
        <EstimateProcess
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 5 && (
        <OwnerApprovalNeeded
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 6 && (
        <CityCitation
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 7 && (
        <DelCityInspection
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 8 && (
        <SectionEight
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 9 && (
        <CancelWorkOrder
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 10 && (
        <WorkOrderCompleted
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
    </div>
  );
};

export default WorkOrderFollowUp;
